module.exports = __webpack_public_path__ + "static/media/el-GR.9b5935e6.md";